import ApiRequest from '../util/ApiRequest'


export const MemberType = {
    'MUDA': 'ASPIRAN',
    'PENUH': 'PROFESIONAL',
    'MITRA': 'MITRA',
    'MITRA_SWASTA': 'MITRA SWASTA TERDAFTAR',
    'KEHORMATAN': 'KEHORMATAN'
}



export default class Member {
    static MEMBER_TYPE_MUDA = 'MUDA'
    static MEMBER_TYPE_PENUH = 'PENUH'
    static MEMBER_TYPE_KEHORMATAN = 'KEHORMATAN'
    static MEMBER_TYPE_MITRA = 'MITRA'
    static MEMBER_TYPE_MITRA_SWASTA = 'MITRA_SWASTA'

    static MITRA_SWASTA_ENTITY_OPTIONS = [
        { value: 'PT', label: 'PT' },
        { value: 'CV', label: 'CV (Commanditaire Vennootschap)' },
        { value: 'FOUNDATION', label: 'YAYASAN' },
        { value: 'CORPORATION', label: 'Koperasi' },
    ]


    static getEntityLabel = (entity) => {
        const labels = {
            'FOUNDATION': 'Yayasan',
            'COMPANY': 'Perusahaan',
            'UNIVERSITY': 'Universitas',
            'INSTITUTION': 'Institusi'
        }
        return labels[entity] || entity
    }

    static getServiceLabel = (key) => {
        const labels = {
            'penerjemahan': 'Penerjemahan',
            'interpreting': 'Interpreting',
            'pelatihan': 'Pelatihan',
            'penyusunan': 'Penyusunan',
            'lainnya': 'Lainnya'
        }
        return labels[key] || key
    }

    login = async (member) => {
        return await ApiRequest.set('v1/member/login', 'POST', member)
    }

    register = async (member) => {
        return await ApiRequest.set('v1/member/register', 'POST', member)
    }

    registerMitra = async (member) => {
        return await ApiRequest.set('v1/member/register-mitra', 'POST', member)
    }

    getMitraSwastaActive = async () => {
        return await ApiRequest.set('v1/members/mitra-swasta/active', 'GET')
    }
    getMitraSwastaActiveByID = async (id) => {
        return await ApiRequest.set(`v1/members/mitra-swasta/active/${id}`, 'GET')
    }

    getMemberById = async (id) => {
        return await ApiRequest.set('v1/member/' + id, 'GET')
    }

    getMemberByHPIId = async (hpi_id) => {
        return await ApiRequest.set('v1/member/hpi_id/' + hpi_id, 'GET')
    }

    getMemberData = async () => {
        return await ApiRequest.set('v1/member/self', 'GET')
    }

    getMemberActivation = async (token, hpi_id) => {
        return await ApiRequest.set('v1/member/activate_page/' + token + '?hpi_id=' + hpi_id, 'GET')
    }

    getActiveMembership = async () => {
        return await ApiRequest.set('v1/membership/active', 'GET')
    }

    editMemberData = async (member) => {
        return await ApiRequest.set('v1/member/self', 'PUT', member)
    }

    search = async (query) => {
        return await ApiRequest.set('v1/members/search/fullname_HPID?query=' + query, 'GET')
    }

    searchAdvanced = async (
        query,
        language_id_from,
        language_id_to,
        profession,
        specializations_id,
        certification,
        tags,
    ) => {
        return await ApiRequest.set(
            '' +
                `v1/members/search/advanced?query=${query}` +
                (language_id_from ? `&language_id_from=${language_id_from}` : '') +
                (language_id_to ? `&language_id_to=${language_id_to}` : '') +
                (profession ? `&profession=${profession}` : '') +
                (specializations_id ? `&specialization_ids=(${specializations_id})` : '') +
                (certification ? `&certification=${certification}` : '') +
                (tags ? `&tags=${tags}` : ''),
            'GET',
        )
    }

    forgotPassword = async (body) => {
        return await ApiRequest.set('v1/member/forgotPassword', 'POST', body)
    }

    resetPassword = async (body) => {
        return await ApiRequest.set('v1/member/resetPassword', 'POST', body)
    }

    finishMigration = async (body) => {
        return await ApiRequest.set('v1/member/activate_migration', 'POST', body)
    }

    changePassword = async (body) => {
        return await ApiRequest.set('v1/member/self/password', 'PUT', body)
    }

    upgradeMembership = async (body) => {
        return await ApiRequest.set('v1/member/upgrade_membership', 'POST', body)
    }

    generateMembershipCertNum = async () => {
        return await ApiRequest.set(`v1/membership/generate_cert_num`, 'GET')
    }

    uploadCertificateUrl = async (id, body) => {
        return await ApiRequest.setMultipart(`v1/membership-certificate/${id}`, 'POST', body)
    }

    getMembershipByToken = async (token) => {
        return await ApiRequest.set(`v1/membership/token/${token}`, "GET");
    }

    getAllActiveClean = async () => {
        return await ApiRequest.set("v1/members/clean", "GET");
    }
}
